import { render, staticRenderFns } from "./AttachmentListViewer.vue?vue&type=template&id=907aa76e&scoped=true"
import script from "./AttachmentListViewer.vue?vue&type=script&lang=js"
export * from "./AttachmentListViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907aa76e",
  null
  
)

export default component.exports